<template>
  <dialog-base
    v-model="modelValue"
    data-testid="accept-tos-dlg"
    size="medium"
    :should-display-close-button="false">
    <template #header>
      <m-group gap="spacing-1">
        <m-text variant="heading-sm-bold">
          {{ $t('auth.dialogs.termsAndConditionsDialog.headers.weValueYourPrivacyAndSecurity') }}
        </m-text>
      </m-group>
    </template>
    <template #body>
      <m-text variant="body-sm" class="m-b-10">
        {{ $t('auth.dialogs.termsAndConditionsDialog.messages.reviewTermsPrefix') }}
        <v-link :is-bold="false" size="sm" :href="termsAndConditionsUrl" target="_blank">
          {{ $t('auth.common.links.termsAndConditions') }}
        </v-link>
        {{ $t('auth.dialogs.termsAndConditionsDialog.messages.reviewTermsMiddle') }}
        <v-link :is-bold="false" size="sm" :href="privacyPolicyUrl" target="_blank">
          {{ $t('auth.common.links.privacyPolicy') }}
        </v-link>
        {{ $t('auth.dialogs.termsAndConditionsDialog.messages.reviewTermsSuffix') }}
      </m-text>
      <m-group class="m-t-5 flex-nowrap" gap="spacing-1">
        <basic-icon
          size="18px"
          @click="toggleTosAccept"
          color="color-primary-60"
          data-testid="accept-tos-checkbox">
          {{ tosAccepted ? 'checkbox-marked' : 'checkbox-blank-outline' }}
        </basic-icon>
        <m-text variant="body-sm">
          {{ $t('auth.dialogs.termsAndConditionsDialog.messages.consentText') }}
        </m-text>
      </m-group>
      <div class="m-t-5">
        <m-text variant="body-sm">
          {{ $t('auth.dialogs.termsAndConditionsDialog.messages.supportPrefix') }}
          <v-link
            :is-bold="false"
            size="sm"
            href="https://community.loadsmart.com/hc/en-us/community/topics/14812876253715-OpenDock"
            target="_blank">
            {{ $t('auth.dialogs.termsAndConditionsDialog.links.supportLinkText') }}
          </v-link>
        </m-text>
      </div>
    </template>
    <template #actions>
      <primary-button :disabled="!tosAccepted" @click="confirm" test-id="confirm-accept-tos-btn">
        {{ $t('auth.dialogs.termsAndConditionsDialog.buttons.confirm') }}
      </primary-button>
    </template>
  </dialog-base>
</template>

<script>
import { BasicIcon, DialogBase, PrimaryButton, VLink } from '@/components';
import dialogMixin from '@/components/mixins/dialogMixin';
import { PRIVACY_POLICY_URL, TERMS_AND_CONDITIONS_URL } from '@/constants/legalLinks';

/**
 * Shown to prompt the user to accept the TOS
 * @displayName Terms and Conditions Dialog
 */
export default {
  name: 'TermsAndConditionsDialog',
  mixins: [dialogMixin],
  components: {
    DialogBase,
    PrimaryButton,
    BasicIcon,
    VLink
  },
  data() {
    return {
      tosAccepted: false,
      termsAndConditionsUrl: TERMS_AND_CONDITIONS_URL,
      privacyPolicyUrl: PRIVACY_POLICY_URL
    };
  },
  methods: {
    async confirm() {
      if (!this.tosAccepted) {
        return;
      }
      this.loading = true;
      await axios
        .post('user/accept-tc')
        .then(() => {
          this.$store.dispatch('Auth/getMe');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleTosAccept() {
      this.tosAccepted = !this.tosAccepted;
    }
  }
};
</script>
